/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItem_user = {
    readonly canShowSellerName: boolean | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "PdpRespSimilarItem_user";
};
export type PdpRespSimilarItem_user$data = PdpRespSimilarItem_user;
export type PdpRespSimilarItem_user$key = {
    readonly " $data"?: PdpRespSimilarItem_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItem_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canShowSellerName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'da2babb66b917e3ca5d688605258153e';
export default node;
